export default __webpack_public_path__ + "static/media/midcap150-valuation-graph2.9a9186d1.jpg";